module.exports = __webpack_public_path__ + "img/example-shared-drive.c0da5b86.png";